import { render, staticRenderFns } from "./DashboardHome.vue?vue&type=template&id=d7049832&scoped=true&"
import script from "./DashboardHome.vue?vue&type=script&lang=js&"
export * from "./DashboardHome.vue?vue&type=script&lang=js&"
import style0 from "./DashboardHome.vue?vue&type=style&index=0&id=d7049832&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7049832",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
